/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import e from "../../core/Collection.js";
import "../../core/asyncUtils.js";
import "../../core/Error.js";
import "../../core/Logger.js";
import "../../core/accessorSupport/watch.js";
import { autorun as r } from "../../core/accessorSupport/trackingUtils.js";
const t = new e(),
  o = new WeakMap();
function n(e) {
  f(e) && t.push(new WeakRef(e));
}
function s(e) {
  const r = t.find(r => r.deref() === e);
  r && t.remove(r);
}
function f(e) {
  return null != e && "object" == typeof e && "refreshInterval" in e && "refresh" in e;
}
function c(e, r) {
  return Number.isFinite(e) && Number.isFinite(r) ? r <= 0 ? e : c(r, e % r) : 0;
}
let i = 0,
  l = 0;
function a() {
  const e = Date.now();
  let r = !1;
  for (const n of t) {
    const t = n.deref();
    if (t) {
      if (t.refreshInterval) {
        e - (o.get(t) ?? 0) + 5 >= 6e4 * t.refreshInterval && (o.set(t, e), t.refresh(e));
      }
    } else r = !0;
  }
  if (r) for (let o = t.length - 1; o >= 0; o--) {
    t.at(o).deref() || t.removeAt(o);
  }
}
r(() => {
  const e = Date.now();
  let r = 0;
  for (const n of t) {
    const t = n.deref();
    t && (r = c(Math.round(6e4 * t.refreshInterval), r), t.refreshInterval ? o.get(t) || o.set(t, e) : o.delete(t));
  }
  if (r !== l) {
    if (l = r, clearInterval(i), 0 === l) return void (i = 0);
    i = setInterval(a, l);
  }
});
const u = {
  get hasRefreshTimer() {
    return i > 0;
  },
  get tickInterval() {
    return l;
  },
  forceRefresh() {
    a();
  },
  hasLayer: e => f(e) && t.some(r => r.deref() === e),
  clear() {
    for (const e of t) {
      const r = e.deref();
      r && o.delete(r);
    }
    t.removeAll();
  }
};
export { n as registerLayer, u as test, s as unregisterLayer };